
import { Component, Vue } from "vue-property-decorator";
import { UserModule } from "../../store/modules/user";
import { screenConfig, screenConfigUpload } from "../../api/modules/user";


@Component({    

})
export default class AccountInfo extends Vue {
  form = {
    orgId: "",
    orgName: UserModule.orgInfo.name,
    title: "",
    backgroundImage: "",
    cornerImage: ""
  };
  
  fileList: any[] = [];
  fileList1: any[] = [];
  formData: any = new FormData();

  created() {
    this.getScreenConfig();
  }

  private getScreenConfig() {
    screenConfig({ orgId: UserModule.orgInfo.orgId }).then(res => {
     console.log(res);
     
      this.form.title = res.title;
      this.form.backgroundImage = res.backgroundImage;
      this.form.cornerImage = res.cornerImage;
    });
  }

  private handleChange1(file: any, fileList: any) {
    let that=this;
    let reader = new FileReader();
    reader.readAsDataURL(file.raw);
    reader.onload = (e: any) => {
      let data=e.target.result;
      let image = new Image();
  
      image.onload = function() {
        console.log(image.width);
        
        let width = image.width;
        let height = image.height;  
    
      // if (width / height!= 1) {
      //   that.$message.error("图片比例不符合要求，请上传1:1比例的图片");
      //   that.fileList1=[]
      //   return;
      // }else{
        that.fileList1 = fileList;
      // }
    }
    image.src = data;
    // this.fileList = fileList;
  }
    //限制图片比例为1920:1080
    // if (file.width / file.height > 1920 / 1080) {
    //   this.$message.error("图片比例不符合要求，请上传1920:1080比例的图片");
    //   return;
    // }else{
    //   this.fileList1 = fileList;
    // }
 
  }
  private handleChange(file: any, fileList: any) {
    // console.log(file, fileList);
    let that=this;
    let reader = new FileReader();
    reader.readAsDataURL(file.raw);
    reader.onload = (e: any) => {
      let data=e.target.result;
      let image = new Image();
  
      image.onload = function() {
        console.log(image.width);
        
        let width = image.width;
        let height = image.height;  
    
      if (width / height!= 1920 / 1080) {
        that.$message.error("图片比例不符合要求，请上传1920:1080比例的图片");
        that.fileList=[]
        return;
      }else{
        that.fileList = fileList;
      }
    }
    image.src = data;
    // this.fileList = fileList;
  }
}


 


  private submitForm() {
    if(this.form.title.length<1){
      this.$message.error("请输入大屏标题");
      return;
    }

    let formData = new FormData();


   


    
    if(this.fileList.length>0){
      formData.append("backgroundFile", this.fileList[0].raw);
      // let bolb=new Blob([this.fileList[0].raw]);
      // let reader=new FileReader();
      // reader.readAsDataURL(bolb);
      // reader.onload=function(e){
      //   console.log(e.target.result);
      //   formData.append("backgroundImage", e.target.result);
      // }
    }else{
      
      

      formData.append("backgroundFile",this.form.backgroundImage);
    }
    if(this.fileList1.length>0){
      formData.append("cornerFile", this.fileList1[0].raw);

      // let bolb=new Blob([this.fileList1[0].raw]);
      // let reader=new FileReader();
      // reader.readAsDataURL(bolb);
      // reader.onload=function(e){
      //   console.log(e.target.result);
      //   formData.append("cornerImage", e.target.result);
      // }
    }else{
      formData.append("cornerFile",this.form.cornerImage);
    }
    formData.append('metadata', JSON.stringify({
      title: this.form.title,
      orgId: UserModule.orgInfo.orgId
    }))
   
   
   console.log(formData.get("backgroundImage"));
   
    console.log(formData.get("metadata"));

    
    
    

    screenConfigUpload(formData).then(res => {
      this.$message.success("上传成功");
      this.getScreenConfig();
    });

    // 提交表单逻辑
  }
}
